import { useState } from 'react';
import { Button, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useDataFetch } from '../../Hooks/Use-data-fetch';

export const FormFilterOrder = ({
  statusFilter,
  setStatusFilter,
  countryFilter,
  setCountryFilter,
  userFilter,
  setUserFilter,
  dateRange,
  setDateRange,
  handleSearch,
  handleGenerateExcel,
  onRegisterOrder,
  onPendingShipments,
  paymentMethodFilter,
  setPaymentMethodFilter,
  wompiReference,
  setWompiReference,
  orderIdFilter,
  setOrderIdFilter,
}) => {
  const { getData } = useDataFetch();
  const [showFilters, setShowFilters] = useState(false);

  const { data: countriesData } = getData(
    ['countries-available'],
    '/product/countries-available/all'
  );

  const [startDate, endDate] = dateRange;

  return (
    <>
      <Row className="gx-3 gy-2 align-items-end mb-2">
        <Col xs="12" md="6" lg="6" xl="6" xxl="6">
          <Button
            color="secondary"
            size="sm"
            onClick={() => setShowFilters((prev) => !prev)}
          >
            <i className="fa fa-filter me-1" />
            Filtros
          </Button>
        </Col>

        <Col xs="12" md="6" lg="6" xl="6" xxl="6">
          <div className="d-flex justify-content-end gap-2">
            <Button
              color="primary"
              size="sm"
              onClick={handleGenerateExcel}
            >
              <i className="fa fa-file-excel-o me-1" />
              Exportar Excel
            </Button>

            <Button
              color="warning"
              size="sm"
              onClick={onPendingShipments}
            >
              <i className="fa fa-truck me-1" />
              Autorizar despacho
            </Button>

            <Button
              color="success"
              size="sm"
              onClick={onRegisterOrder}
            >
              <i className="fa fa-plus-circle me-1" />
              Registrar orden
            </Button>
          </div>
        </Col>
      </Row>

      {showFilters && (
        <Row className="gx-3 gy-3 align-items-end mb-3">
          <Col xs="12" sm="6" md="4" lg="3" xl="1">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1">ID Orden</Label>
              <Input
                type="text"
                bsSize="sm"
                placeholder="ID de la orden"
                value={orderIdFilter}
                onChange={(e) => setOrderIdFilter(e.target.value)}
              />
            </FormGroup>
          </Col>

          <Col xs="12" sm="6" md="4" lg="3" xl="1">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1">Usuario</Label>
              <Input
                type="text"
                bsSize="sm"
                placeholder="Nombre"
                value={userFilter}
                onChange={(e) => setUserFilter(e.target.value)}
              />
            </FormGroup>
          </Col>

          <Col xs="12" sm="6" md="4" lg="3" xl="2">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1">
                Referencia Wompi
              </Label>
              <Input
                type="text"
                bsSize="sm"
                placeholder="Referencia Wompi"
                value={wompiReference}
                onChange={(e) => setWompiReference(e.target.value)}
              />
            </FormGroup>
          </Col>

          <Col xs="12" sm="6" md="4" lg="3" xl="1">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1">Estado</Label>
              <Input
                type="select"
                bsSize="sm"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="CREATED">Creada</option>
                <option value="PAID">Pagada</option>
                <option value="PROCESSING">En proceso</option>
                <option value="SHIPPED">Enviada</option>
                <option value="DELIVERED">Entregada</option>
                <option value="CANCELLED">Cancelada</option>
                <option value="RETURNED">Devuelta</option>
              </Input>
            </FormGroup>
          </Col>

          <Col xs="12" sm="6" md="4" lg="3" xl="1">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1">País</Label>
              <Input
                type="select"
                bsSize="sm"
                value={countryFilter}
                onChange={(e) => setCountryFilter(e.target.value)}
              >
                <option value="">Todos</option>
                {countriesData?.data?.countries?.map((country) => (
                  <option key={country.id} value={country.name}>
                    {country.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col xs="12" sm="6" md="4" lg="3" xl="1">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1">
                Método de Pago
              </Label>
              <Input
                type="select"
                bsSize="sm"
                value={paymentMethodFilter}
                onChange={(e) =>
                  setPaymentMethodFilter(e.target.value)
                }
              >
                <option value="">Todos</option>
                <option value="CASH">Efectivo</option>
                <option value="TRANSFER">Transferencia</option>
                <option value="LINK">Link de pago</option>
                <option value="PROVIDER">Proveedor</option>
              </Input>
            </FormGroup>
          </Col>

          <Col xs="12" sm="6" md="6" lg="4" xl="2">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1">Fechas</Label>
              <DatePicker
                className="form-control form-control-sm"
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => setDateRange(update)}
                showMonthDropdown
                showYearDropdown
                dateFormat="MMMM d, yyyy h:mm aa"
                placeholderText="Selecciona un rango"
                isClearable
              />
            </FormGroup>
          </Col>

          <Col xs="12" sm="6" md="6" lg="3" xl="1">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1 d-block">
                &nbsp;
              </Label>

              <Button
                color="primary"
                size="sm"
                onClick={handleSearch}
                className="w-100"
              >
                <i className="fa fa-search me-1" />
                Buscar
              </Button>
            </FormGroup>
          </Col>
        </Row>
      )}
    </>
  );
};